// extracted by mini-css-extract-plugin
module.exports = {"main":"TableCells_main__wHtcL","list":"TableCells_list__3I-a3","firstItemBold":"TableCells_firstItemBold__2uPcI","link":"TableCells_link__2rIpL"};